import React, { useEffect, useRef, useState } from 'react';
import s from './GoalWeight.module.scss';

const GoalWeight = props => {
  const { onInputChange, restoreScrollPosition, unit } = props;
  const [weight, setWeight] = useState('');
  const weightInputRef = useRef(null);

  useEffect(() => {
    if (weightInputRef.current) {
      weightInputRef.current.focus();
    }
  }, []);

  const handleWeightChange = event => {
    let newWeight = event.target.value;
    newWeight = newWeight.replace(/[^0-9.,]/g, '');
    newWeight = newWeight.replace(/^0+/, '');

    const validFormat = /^[0-9]*[.,]?[0-9]*$/;

    if (validFormat.test(newWeight) && newWeight <= 999) {
      setWeight(newWeight);
      onInputChange(newWeight, unit);
    }
  };

  useEffect(() => {
    onInputChange(weight, unit);
  }, [weight, unit, onInputChange]);

  return (
    <div className={s.goalWeight}>
      <div className={s.weightInput}>
        <input
          ref={weightInputRef}
          type='text'
          inputMode='decimal'
          pattern='[0-9.,]*'
          value={weight}
          onChange={handleWeightChange}
          onBlur={restoreScrollPosition}
        />
        {unit}
      </div>
    </div>
  );
};

export default GoalWeight;
